export enum AttachmentType {
    unknown = 0,
    application = 1,
    audio = 2,
    font = 3,
    example = 4,
    image = 5,
    message = 6,
    model = 7,
    multipart = 8,
    text = 9,
    video = 10,
    share = 11,
    iframe = 12,
    carousel = 13,
    link = 14,
}
